<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-card dark>
      <v-card-title>
        <span class="headline">Compose Mail</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field label="To" v-model="to"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field label="Subject" v-model="subject"></v-text-field>
            </v-col>
            <v-col cols="12">
              <VueEditor v-model="body" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="send">Send</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { VueEditor } from "vue2-editor"

export default {
  name: "ComposeMail",
  components: { VueEditor },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    replyTo: {
      type: Object,
      default: null,
    },
    forward: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    to: "",
    subject: "",
    body: "",
  }),
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      },
    },
  },
  watch: {
    replyTo: {
      handler: "updateFields",
      immediate: true,
    },
    forward: "updateFields",
  },
  methods: {
    updateFields() {
      if (this.replyTo) {
        if (this.forward) {
          this.to = ""
          this.subject = `Fwd: ${this.replyTo.subject}`
          this.body = `\n\n-------- Forwarded Message --------\nFrom: ${this.replyTo.from}\nTo: ${this.replyTo.to}\nDate: ${this.replyTo.date}\nSubject: ${this.replyTo.subject}\n\n${this.replyTo.body}`
        } else {
          this.to = this.replyTo.from
          this.subject = `Re: ${this.replyTo.subject}`
          this.body = this.replyTo.draft || `\n\n> ${this.replyTo.body.replace(/\n/g, "\n> ")}`
        }
      }
    },
    close() {
      this.dialog = false
    },
    send() {
      this.$store.dispatch("mailStore/sendEmail", {
        to: this.to,
        subject: this.subject,
        text: this.body,
        replyTo: this.replyTo && !this.forward ? this.replyTo._id : null,
      })
      this.close()
    },
  },
}
</script>

<style scoped>
.v-card {
  background-color: #2c2c2c !important;
  color: #ffffff !important;
}

.v-btn {
  color: #ffffff !important;
}

.v-text-field input,
.v-textarea {
  color: #ffffff !important;
}

.v-label {
  color: #b0b0b0 !important;
}
</style>
